import { H4 } from 'foundations-components/transitional/components/H4';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import ApprovalButtons from '../consumer/ApprovalButtons';
import { ApprovalEmptyStateI18nFirstSection, ApprovalEmptyStateI18nSecondSection, ApprovalEmptyStateI18nTitle } from '../i18n/ApprovalEmptyStateI18n';
import { View } from 'foundations-components/transitional/components/View';
import { Paragraph } from 'foundations-components/transitional/components/Paragraph';
import { useApprovalContext } from '../../hooks/useApprovalContext';
import { ApprovalTypes } from '../../types/ApprovalType';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function ApprovalEmptyState() {
  const approval = useApprovalContext();
  const approvalType = approval.meta.approvalType;
  const isQuote = approvalType === ApprovalTypes.QUOTE;
  return /*#__PURE__*/_jsx(View, {
    "data-test-id": "product-approvals-approval-sidebar-empty-state",
    padding: "500",
    as: "div",
    children: /*#__PURE__*/_jsxs(ErrorMessage, {
      type: "notFound",
      marginBlockEnd: "500",
      illustration: "approvals",
      illustrationProps: {
        width: 150
      },
      title: /*#__PURE__*/_jsx(H4, {
        children: /*#__PURE__*/_jsx(ApprovalEmptyStateI18nTitle, {})
      }),
      children: [!isQuote && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Paragraph, {
          children: /*#__PURE__*/_jsx(ApprovalEmptyStateI18nFirstSection, {})
        }), /*#__PURE__*/_jsx(Paragraph, {
          children: /*#__PURE__*/_jsx(ApprovalEmptyStateI18nSecondSection, {})
        })]
      }), /*#__PURE__*/_jsx(ApprovalButtons, {
        children: /*#__PURE__*/_jsx(_Fragment, {})
      })]
    })
  });
}
export default ApprovalEmptyState;